// Utilidades de consola/pruebas. Expone helpers sin coste en runtime.
// Cumple el requisito VRTC de poder inspeccionar desde la consola del navegador.
import { supabase } from './supabase';
import { useApp } from '../store/useApp';
import * as offline from '../offline/db';
import { sincronizar } from '../offline/sync';
import { readAllContracts } from '../verify/contract';
import { onActualizacion, aplicarActualizacion, esChunkError, recuperarDeChunkError, simularActualizacion } from './appUpdate';

if (typeof window !== 'undefined') {
  window.supabase = supabase;
  window.__app = useApp;
  window.__hueco = { ...offline, sincronizar, readAllContracts };
  // Helpers de actualización/recuperación (inspección desde consola y pruebas).
  window.__update = { onActualizacion, aplicarActualizacion, esChunkError, recuperarDeChunkError, simularActualizacion };
}
